/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { MdeOnboardings } from "../operationsInterfaces";
import * as coreClient from "@azure/core-client";
import * as Mappers from "../models/mappers";
import * as Parameters from "../models/parameters";
import { SecurityCenter } from "../securityCenter";
import {
  MdeOnboardingsListOptionalParams,
  MdeOnboardingsListResponse,
  MdeOnboardingsGetOptionalParams,
  MdeOnboardingsGetResponse
} from "../models";

/** Class containing MdeOnboardings operations. */
export class MdeOnboardingsImpl implements MdeOnboardings {
  private readonly client: SecurityCenter;

  /**
   * Initialize a new instance of the class MdeOnboardings class.
   * @param client Reference to the service client
   */
  constructor(client: SecurityCenter) {
    this.client = client;
  }

  /**
   * The configuration or data needed to onboard the machine to MDE
   * @param options The options parameters.
   */
  list(
    options?: MdeOnboardingsListOptionalParams
  ): Promise<MdeOnboardingsListResponse> {
    return this.client.sendOperationRequest({ options }, listOperationSpec);
  }

  /**
   * The default configuration or data needed to onboard the machine to MDE
   * @param options The options parameters.
   */
  get(
    options?: MdeOnboardingsGetOptionalParams
  ): Promise<MdeOnboardingsGetResponse> {
    return this.client.sendOperationRequest({ options }, getOperationSpec);
  }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const listOperationSpec: coreClient.OperationSpec = {
  path:
    "/subscriptions/{subscriptionId}/providers/Microsoft.Security/mdeOnboardings",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.MdeOnboardingDataList
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.$host, Parameters.subscriptionId],
  headerParameters: [Parameters.accept],
  serializer
};
const getOperationSpec: coreClient.OperationSpec = {
  path:
    "/subscriptions/{subscriptionId}/providers/Microsoft.Security/mdeOnboardings/default",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.MdeOnboardingData
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.$host, Parameters.subscriptionId],
  headerParameters: [Parameters.accept],
  serializer
};
